<template>
	<section id="wrapper" class="login-register">
		<div class="login-box login-sidebar">
			<router-view
				:user="user"
				:isAuth="isAuth">
			</router-view>
		</div>
	</section>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/authentication/layout/Authentication.vue